import React, { } from 'react';
import { Chip as MuiChip, useTheme } from '@material-ui/core';
import { useChipStyle } from './style';
import { color } from '@internal/plugin-components-react';















export var ChipType; (function (ChipType) {
  const warning = 0; ChipType[ChipType["warning"] = warning] = "warning";
  const warningOutlined = warning + 1; ChipType[ChipType["warningOutlined"] = warningOutlined] = "warningOutlined";
  const success = warningOutlined + 1; ChipType[ChipType["success"] = success] = "success";
  const successOutlined = success + 1; ChipType[ChipType["successOutlined"] = successOutlined] = "successOutlined";
  const error = successOutlined + 1; ChipType[ChipType["error"] = error] = "error";
  const errorOutlined = error + 1; ChipType[ChipType["errorOutlined"] = errorOutlined] = "errorOutlined";
  const infoOutlined = errorOutlined + 1; ChipType[ChipType["infoOutlined"] = infoOutlined] = "infoOutlined";
  const tag = infoOutlined + 1; ChipType[ChipType["tag"] = tag] = "tag";
  const blue = tag + 1; ChipType[ChipType["blue"] = blue] = "blue";
  const lightBlue = blue + 1; ChipType[ChipType["lightBlue"] = lightBlue] = "lightBlue";
  const lightYellow = lightBlue + 1; ChipType[ChipType["lightYellow"] = lightYellow] = "lightYellow";
  const lightGreen = lightYellow + 1; ChipType[ChipType["lightGreen"] = lightGreen] = "lightGreen";
  const paper = lightGreen + 1; ChipType[ChipType["paper"] = paper] = "paper";
})(ChipType || (ChipType = {}));

export function ChipComponent({
  className,
  label,
  size,
  isTinyBorder,
  type = ChipType.tag,
  style,
  onDelete,
  icon,
  deleteIcon,
}) {
  const theme = useTheme();
  const chipType = () => {
    switch (type) {
      case ChipType.error:
        return {
          color: theme.palette.common.white,
          background: theme.palette.error.main,
        };
      case ChipType.warning:
        return {
          color: theme.palette.common.white,
          background: theme.palette.warning.main,
        };
      case ChipType.success:
        return {
          color: theme.palette.common.white,
          background: theme.palette.success.main,
        };
      case ChipType.tag:
        return {
          color: theme.palette.text.primary,
          background: theme.palette.neutral.backgroundSoft,
        };
      case ChipType.lightBlue:
        return {
          color: color.ui.blue.N900,
          background: color.ui.blue.N100,
        };
      case ChipType.lightYellow:
        return {
          color: color.ui.orange.N600,
          background: color.ui.orange[100],
        };
      case ChipType.lightGreen:
        return {
          color: color.ui.green.N900,
          background: color.ui.green.N100,
        };
      case ChipType.blue:
        return {
          color: theme.palette.common.white,
          background: theme.palette.primary.main,
        };
      case ChipType.paper:
        return {
          color: theme.palette.text.primary,
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.border}`,
        };
      case ChipType.warningOutlined:
        return {
          color: theme.palette.warning.dark,
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.warning.dark}`,
        };
      case ChipType.successOutlined:
        return {
          color: theme.palette.success.dark,
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.success.dark}`,
        };
      case ChipType.errorOutlined:
        return {
          color: theme.palette.error.dark,
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.error.dark}`,
        };
      case ChipType.infoOutlined:
        return {
          color: theme.palette.info.main,
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.info.main}`,
          '&:hover': {
            background: theme.palette.info.backgroundSoft,
          },
        };
      default:
        return {};
    }
  };

  const defaultPropsStyle = {
    borderRadius: isTinyBorder ? 4 : undefined,
    ...chipType(),
  };

  const classes = useChipStyle(defaultPropsStyle, style)();

  const handleDelete = () => {
    if (onDelete) {
      onDelete(label);
    }
  };

  return (
    React.createElement(MuiChip, {
      classes: {
        root: classes.root,
      },
      className: className,
      label: label,
      size: size,
      onDelete: onDelete ? handleDelete : undefined,
      icon: icon,
      deleteIcon: deleteIcon,}
    )
  );
}
